import { render, staticRenderFns } from "./SystemList.vue?vue&type=template&id=5da60d6d&"
import script from "./SystemList.vue?vue&type=script&lang=js&"
export * from "./SystemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports